module.exports = __webpack_public_path__ + "logo-orkla-tagline-com-white-b7c03cae078a80f7a8d038c8c319af9b.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-com-white.svg
// module id = 59
// module chunks = 0